function insertIframe(e) {
    var videoItem = e.target.closest('.js-video-item')
    if (videoItem) {
        var iframeVideo = videoItem.getAttribute('data-video')
        var popupVideoContainer = document.querySelector('.js-video-iframe')
        popupVideoContainer.innerHTML = iframeVideo
        popupVideoContainer.querySelector('iframe').src += '?autoplay=1'
    }
}

function closePopupVideo(e) {
    var closeButton = e.target.closest('.popup-video .js-popup-close')
    if (closeButton) {
        document.querySelector('.js-video-iframe iframe').src = ''
    }
}

window.addEventListener('popup:close', function (e) {
    const popupVideo = document.getElementById(e.detail.data)
    if (popupVideo.classList.contains('popup-video')) {
        document.querySelector('.js-video-iframe iframe').src = ''
    }
})

document.addEventListener('click', insertIframe);
document.addEventListener('click', closePopupVideo);
